module.exports = __webpack_public_path__ + "static/yun-jin-6a26abd4744133396fe6c42e51d80646.png";